








































import { Vue, Component } from 'vue-property-decorator';

import * as ROUTES from '@/constants/routes';
import * as authService from '@/services/auth';
import { logoInvertedImage } from '@/assets/images';
import * as storageService from '@/services/storage';

@Component
export default class Login extends Vue {
  private form: any;
  private errorMessage: string = '';
  private submitting: boolean = false;
  private logo: string = logoInvertedImage;

  private beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  private handleSubmit(e: any) {
    e.preventDefault();

    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.errorMessage = '';
        this.submitting = true;

        const { email, password } = values;

        authService
          .checkIfLoggedIn(email, password)
          .then((data: any) => {
            if (data && data.accessToken) {
              const params = {
                accessToken: data.accessToken,
                refreshToken: data.refreshToken
              };

              storageService.setUserSession(params);

              this.$router.push(ROUTES.DASHBOARD);

              return;
            } else {
              this.errorMessage = data.message;
            }
          })
          .catch((error: any) => {
            this.errorMessage = error.message;
          })
          .then(() => {
            this.submitting = false;
          });
      }
    });
  }
}
